// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  padding: 1.5rem 0;
  transition: all 0.3s ease;
  background: transparent;
}

.header.scrolled {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 1rem 0;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-text {
  font-size: 1.8rem;
  font-weight: 700;
  background: linear-gradient(45deg, #2c3e50, #3498db);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: all 0.3s ease;
}

.logo a {
  text-decoration: none;
}

.nav-menu {
  display: flex;
  gap: 2.5rem;
}

.nav-link {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.1rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: #3498db;
  transition: width 0.3s ease;
}

.nav-link:hover::after,
.nav-link.active::after {
  width: 80%;
}

.nav-link:hover {
  color: #3498db;
}

.nav-link.active {
  color: #3498db;
  background: rgba(52, 152, 219, 0.1);
}

.menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-menu {
    gap: 1rem;
  }

  .nav-link {
    font-size: 1rem;
    padding: 0.4rem 0.8rem;
  }

  .menu-toggle {
    display: block;
    background: none;
    border: none;
    cursor: pointer;
  }

  .nav-menu {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 1rem;
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }

  .nav-menu.active {
    transform: translateY(0);
  }

  .nav-menu ul {
    flex-direction: column;
  }

  .nav-menu li {
    margin: 1rem 0;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,aAAa;IACb,4BAA4B;IAC5B,sCAAsC;EACxC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".header {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n  padding: 1.5rem 0;\n  transition: all 0.3s ease;\n  background: transparent;\n}\n\n.header.scrolled {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  padding: 1rem 0;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);\n}\n\n.header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo-text {\n  font-size: 1.8rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #2c3e50, #3498db);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  transition: all 0.3s ease;\n}\n\n.logo a {\n  text-decoration: none;\n}\n\n.nav-menu {\n  display: flex;\n  gap: 2.5rem;\n}\n\n.nav-link {\n  color: #2c3e50;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1.1rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.nav-link::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 2px;\n  background: #3498db;\n  transition: width 0.3s ease;\n}\n\n.nav-link:hover::after,\n.nav-link.active::after {\n  width: 80%;\n}\n\n.nav-link:hover {\n  color: #3498db;\n}\n\n.nav-link.active {\n  color: #3498db;\n  background: rgba(52, 152, 219, 0.1);\n}\n\n.menu-toggle {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .header-content {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .nav-menu {\n    gap: 1rem;\n  }\n\n  .nav-link {\n    font-size: 1rem;\n    padding: 0.4rem 0.8rem;\n  }\n\n  .menu-toggle {\n    display: block;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n\n  .nav-menu {\n    position: fixed;\n    top: 70px;\n    left: 0;\n    right: 0;\n    background-color: #fff;\n    padding: 1rem;\n    transform: translateY(-100%);\n    transition: transform 0.3s ease-in-out;\n  }\n\n  .nav-menu.active {\n    transform: translateY(0);\n  }\n\n  .nav-menu ul {\n    flex-direction: column;\n  }\n\n  .nav-menu li {\n    margin: 1rem 0;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
